const APIRequest = require('components/api_request.js');

class InferCategoryQuery {
  constructor(make, model) {
    this.make = make.trim();
    this.model = model.trim();
  }

  sameAs(query) {
    return query.make === this.make && query.model === this.model;
  }

  get hasAllParts() {
    return this.make.length !== 0 && this.model.length !== 0;
  }

  fetch() {
    return APIRequest.get(
      '/listings/infer_category_id',
      { make: this.make, model: this.model },
    );
  }
}

module.exports = InferCategoryQuery;



// WEBPACK FOOTER //
// ./javascripts/components/category_select/infer_category_query.js